import(/* webpackMode: "eager" */ "D:\\git\\fh-app\\fh-fe\\src\\app\\global-error.tsx");
